/* eslint-disable react/no-array-index-key */
import clsx from 'clsx';
import { FC } from 'react';

import Badge from 'molecules/Badge';
import Button from 'molecules/Button';
import Image from 'molecules/Image';
import Link from 'molecules/Link';

import { resourceCardStyle } from 'organisms/Cards/Resource/styles';
import { getTagArray } from 'organisms/Cards/Resource/utils';

import { hasArrayValues } from 'utils/array/arrays';

interface ResourceCardProps extends Resource {
  linkTo?: string;
  isDark?: boolean;
}

const ResourceCard: FC<ResourceCardProps> = ({
  featuredImage,
  title,
  tags,
  linkTo,
  url,
  summary,
  isDark,
  isDarkGradient,
  priority = false,
}) => {
  const tagArray = getTagArray(tags);
  const isDarkCard = isDark || isDarkGradient;

  return (
    <Link
      href={linkTo || url}
      aria-label={title}
      className={resourceCardStyle({ isDark, isDarkGradient })}
      enablePreview={false}
    >
      {featuredImage && (
        <div className="overflow-hidden rounded-lg">
          <div className="overflow-hidden rounded-lg bg-gray-900">
            <Image
              url={featuredImage?.file?.url || featuredImage?.url}
              width={400}
              height={225}
              noFill={true}
              className="w-full"
              objectCover
              alt={featuredImage?.alt || featuredImage?.display_name || ''}
              sizes="(max-width: 640px) 100vw, (max-width: 768px) 50vw, (max-width: 1024px) 33vw, 400px"
              priority={priority}
              loading={priority ? 'eager' : 'lazy'}
            />
          </div>
        </div>
      )}
      <div className="flex grow flex-col justify-between gap-4">
        <div className="flex flex-col gap-4">
          <div className="flex flex-wrap gap-2">
            {hasArrayValues(tagArray) &&
              tagArray?.map((tag, idx) => <Badge key={idx} label={tag} color={isDarkCard ? 'gray' : 'light'} />)}
          </div>
          <span className={clsx('line-clamp-3 text-xl font-bold ', isDarkCard ? 'text-white' : 'text-gray-900')}>
            {title}
          </span>
          <span className={clsx('line-clamp-2 text-md ', isDarkCard ? 'text-gray-300' : 'text-gray-700')}>
            {summary}
          </span>
        </div>
        <div className="dark">
          <Button
            label="Learn More"
            hierarchy={isDarkCard ? 'linkColor' : 'linkLight'}
            endIcon="arrow-up-right"
            className={isDark ? 'dark:hover:!text-primary-300 dark:group-hover:!text-primary-300' : undefined}
          />
        </div>
      </div>
    </Link>
  );
};

export default ResourceCard;
